import React from 'react';

import { defineMessages, t } from '@sm/intl';

import ListingsBasePage from './ListingsBasePage';

const COPY = defineMessages({
  PAGE_TITLE: {
    id: 'Listings.MostPopular.Title',
    defaultMessage: 'Most Popular',
    description:
      '[Type: Header][Vis.: high] - The title of the page for the most popular installed apps.'
  }
});

const MostPopular = () => {
  return (
    <ListingsBasePage
      pageId="App Directory - Most Popular"
      filter="MOST_POPULAR"
      title={t(COPY.PAGE_TITLE)}
    />
  );
};

export default MostPopular;
